/** Id of the drawer, controlled by the header hamburger while the drawer is in use. */
export const MOBILE_TOP_LEVEL_NAVIGATION_ID = 'mobile-top-level-navigation';

export const MOBILE_NAVIGATION_PANEL_ID = 'mobile-top-level-navigation-panel';

/** Id of the nested Account view, opened from the logged-in login row. */
export const ACCOUNT_VIEW_ID = 'account';

export const LOGIN_ROW_ID = 'mobile-top-level-navigation-login';

export const LOCALE_ROW_DESCRIPTION_ID = 'mobile-top-level-navigation-locale-description';

/** Hidden name of the open level 2 section: names its region and describes the Back button. */
export const SECTION_NAME_ID = 'mobile-top-level-navigation-section-name';

/**
 * Stacking layer of the drawer and of the overlays it opens (above the header, z-index 504). The
 * overlays' own z-index is relative to this layer.
 */
export const DRAWER_Z_INDEX = 505;
